module.exports = require("./../../_gen/starling/rendering/VertexData");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/VertexData.js
// module id = 218
// module chunks = 0